<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
        :send-all-form="true"
        :is-edit-settings="true"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import addCollectionsToScheme from "@/utils/addCollectionsToScheme";
import {
  getHubMeta as fetchData,
  postHubMeta as updateData,
} from "@/api/hubMeta";
import { HubMeta as defaultScheme } from "@/api/schemes/hubMeta";

const updateScheme = async (scheme) => {
  try {
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        fetchData,
        updateData,
        updateScheme,
      },
    };
  },
};
</script>
